import React from 'react';
import PropTypes from 'prop-types';

class Tags extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'Tags';
        this.refreshTags = this.refreshTags.bind(this);
    }
    componentDidMount() {
    	var _self = this;
     	var ti = $('#tags-input-multiple');
     	ti.tagsinput();
   		ti.on('itemAdded', function(event) {
   			console.log("Item Added.");
   			var tags = ti.tagsinput('items');

   			if(typeof _self.props.onChange === 'function')
				_self.props.onChange(tags);
   		});

   		if(typeof this.props.tags === 'object')
   			this.props.tags.forEach(function (tag) {
   				ti.tagsinput('add',tag);
   			});
    }
    refreshTags () {
      var ti = $('#tags-input-multiple');
      if(typeof this.props.tags === 'object')
        this.props.tags.forEach(function (tag) {
          ti.tagsinput('add',tag);
        });
    }
    componentDidUpdate(prevProps, prevState) {
      this.refreshTags();     
    }
    render() {
    	  
        return(
        	<div className="form-group">
				<p><label className="control-label">Create your Post Tags.</label></p>
					<select id="tags-input-multiple" multiple data-role="tagsinput" data-tag-class="label label-primary"></select>
					<p>These will show up in the meta.</p>
			</div>
        );
    }
}

export default Tags;



// WEBPACK FOOTER //
// ./src/browser/components/forms/Tags.js